/* file description */
import { Api } from '@cui/req';

const assetBaseUrl = '/api/gateway/metabase';
// 单模型接口（默认技术空间）
const singleModelUrl = `${assetBaseUrl}/api/v1/tech`;
const pageModel = 'page';
const pageVersionModel = 'page_version';


// 获取页面列表
export const getPageList = (data: Record<string, any>) => Api({
  url: `${singleModelUrl}/${pageModel}/page`,
  method: 'POST',
  data,
});

// 获取对应页面版本 与页面关系是头行，页面是头，页面版本是行
export const getPageVersionList = (data: Record<string, any>) => Api({
  url: `${singleModelUrl}/${pageVersionModel}/page`,
  method: 'POST',
  data,
});


export const getImportTemplate = async (task_id: string, route: string) => {
  const res: Response = await fetch(`/api/gateway/metabase/excel/v1/tpl_export/${task_id}?${new URLSearchParams({ route })}`, {
    method: 'POST',
  });
  return res;
};

// TODO
// export const downloadImportTemplateCache = promiseCacher(downloadImportTemplate);
